import React from 'react'

import { Badge, Box, IconButton, TextField, Tooltip } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import WarningIcon from '@material-ui/icons/Warning'
import Autocomplete from '@material-ui/lab/Autocomplete'
import styles from 'assets/jss/material-dashboard-pro-react/components/exceptionFieldsStyle'
import { checkErrorOrWarning } from 'utils/functions'

import { CircularProgress } from '@material-ui/core'
import { useGetBuyerAddress } from 'hooks/useMasterData'
import { ColumnsOrderLineItems } from 'utils/Constants'

const useStyles = makeStyles(styles)

const BuyerAddSelectLineItem = props => {
  const {
    label,
    validationErrorsState,
    field,
    handleChange,
    value,
    lineId,
    companyCode,
    removeWarningLineItem,
    readOnly,
    appId
  } = props

  const classes = useStyles()
  const fieldType = field === ColumnsOrderLineItems.BUYER_SHIP_TO_ADDRESS ? 'shipTo' : 'billTo'
  const addresses = useGetBuyerAddress({
    companyCode: companyCode ?? '',
    params: {
      type: fieldType,
      status: 'enabled',
      appId
    }
  })

  const validated = validationErrorsState[`${field}.${lineId}`]?.valid ?? null

  const message = validationErrorsState[`${field}.${lineId}`]?.messages

  const typeMsg = checkErrorOrWarning(message, validated)

  let tooltipArrowClass = null
  let tooltipClass = null
  let badgeClass = null

  if (typeMsg === 'warning') {
    tooltipArrowClass = classes.warningColor
    tooltipClass = classes.tooltipWarning
    badgeClass = classes.badgeWarning
  } else if (typeMsg === 'error') {
    tooltipArrowClass = classes.errorColor
    tooltipClass = classes.tooltipError
    badgeClass = classes.badgeError
  }

  function validationMessages(validationsError) {
    if (!validationsError) {
      return ''
    }

    if (Array.isArray(validationsError)) {
      return (
        <>
          {validationsError.map((message, index) => (
            <div key={index}>{message.message}</div>
          ))}
        </>
      )
    }

    const messages = validationsError.split('\n')

    return (
      <>
        {messages.map((message, index) => (
          <div key={index}>{message}</div>
        ))}
      </>
    )
  }

  return (
    <Box style={{ display: 'flex', justifyContent: 'center' }}>
      <Tooltip
        classes={{
          arrow: tooltipArrowClass,
          tooltip: tooltipClass
        }}
        title={typeMsg !== '' ? validationMessages(message) : ''}
        arrow
        placement="right"
      >
        <Badge
          classes={{
            badge: badgeClass
          }}
          badgeContent={
            typeMsg === 'warning' ? (
              <WarningIcon className={classes.warningColor}></WarningIcon>
            ) : null
          }
          invisible={typeMsg !== '' ? true : false}
        >
          <Autocomplete
            value={value}
            onChange={(event, newValue) => {
              handleChange(newValue)
            }}
            id="asynchronous-demo"
            disableClearable
            style={{ width: 300 }}
            getOptionSelected={(option, value) => option.fullAddress === value.fullAddress}
            getOptionLabel={option => option.fullAddress}
            options={addresses.data ?? []}
            loading={addresses.isLoading}
            disabled={readOnly}
            className={readOnly ? classes.readOnly : ''}
            renderInput={params => (
              <TextField
                {...params}
                label={label}
                variant="outlined"
                fullWidth
                multiline
                error={typeMsg === 'error' ? true : false}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {addresses.isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  ),
                  classes: {
                    notchedOutline: typeMsg === 'warning' ? classes.inputWarning : ''
                  }
                }}
                InputLabelProps={{
                  classes: {
                    root: typeMsg === 'warning' ? classes.warningColor : '',
                    focused: typeMsg === 'warning' ? classes.warningColor : ''
                  }
                }}
              />
            )}
          />
        </Badge>
      </Tooltip>
      {typeMsg === 'warning' ? (
        <IconButton
          style={{ padding: '0', marginLeft: '10px' }}
          className={classes.buttonSuccess}
          onClick={() => removeWarningLineItem(field, lineId)}
        >
          <CheckCircleOutlineIcon className={classes.successColor} />
        </IconButton>
      ) : null}
    </Box>
  )
}

export default BuyerAddSelectLineItem
